import { useRef, useState, useEffect } from "react";
import { useFrame } from "@react-three/fiber";

import MemberCircle from "./MemberCircle";
import { load } from "js-yaml";
import { useScroll } from "@react-three/drei";
import { Vector2, Vector3, IcosahedronGeometry } from "three";
import { nanoid } from "nanoid";
import { useStore } from "../store";

export default function MemberSphere(props) {
  const ref = useRef();
  const scroll = useScroll();
  const [members, setMembers] = useState([]);
  const curve = props.curve;
  let role = useStore((state) => state[props.store]);

  // MemberSphere를 회전 시킬 방향을 랜덤하게 정함
  const theta = Math.random() * Math.PI * 2;
  const rotationDirection = new Vector2(Math.sin(theta), Math.cos(theta));
  rotationDirection.multiplyScalar(0.002);

  // Icosahedron Geometry의 vertcies를 이용해 위치 후보 생성
  const ico = new IcosahedronGeometry(3.5, 2).attributes.position.array;
  let icoVertices = [];
  for (let j = 0; j < ico.length; j += 3) {
    const p = [ico[j], ico[j + 1], ico[j + 2]];
    if (icoVertices.indexOf(p) === -1) icoVertices.push(p);
  }

  useFrame(() => {
    const startOffset = 0.15;
    const end = 0.9;
    const t = (scroll.offset - startOffset) / (end - startOffset);
    if ((t < 0) | (t > 1)) return;

    ref.current.scale.x = t;
    ref.current.scale.y = t;
    ref.current.scale.z = t;
    ref.current.position.x = curve.getPointAt(t).x;
    ref.current.position.y = curve.getPointAt(t).y;
    ref.current.position.z = curve.getPointAt(t).z;

    ref.current.children.forEach((mesh) => {
      mesh.lookAt(ref.current.position);
      mesh.material.opacity = Math.max(t - 0.25, 0) * 5;
    });

    ref.current.rotation.x += rotationDirection.x;
    ref.current.rotation.y += rotationDirection.y;
  });

  useEffect(() => {
    fetch("members.yaml")
      .then((r) => r.text())
      .then((text) => {
        return load(text);
      })
      .then((data) => {
        // 특정 role에 해당하는 멤버들만 필터링
        let data2 = data.map((d, i) => {
          return { ...d, num: i };
        });
        let filtered = data2.filter((d) => d.role.indexOf(role[0]) !== -1);

        for (let i = 0; i < filtered.length; i++) {
          const idx = Math.floor(Math.random() * icoVertices.length);
          const pos = icoVertices.splice(idx, 1)[0];
          filtered[i].position = new Vector3(pos[0], pos[1], pos[2]);
          filtered[i].isMember = true;
        }

        setMembers(filtered);
      });

    ref.current.scale.x = 0;
    ref.current.scale.y = 0;
    ref.current.scale.z = 0;
  }, [role]);

  return (
    <group ref={ref}>
      {members.map((member) => (
        <MemberCircle
          key={nanoid()}
          name={member.name}
          num={member.num}
          img={member.img}
          position={member.position}
          center={new Vector3(0, 0, 0)}
          isDirected={true}
          isMember={member.isMember}
          opacity={0.5}
        />
      ))}
    </group>
  );
}
